<div class="dxc-otp" role="group" [attr.aria-label]="ariaLabel">
  @for (cell of cells; track $index) {
    <input #cellInput type="text" class="dxc-otp__cell" inputmode="numeric" pattern="[0-9]*"
      [class.is-invalid]="invalid" [disabled]="disabled"
      [attr.autocomplete]="$index === 0 ? 'one-time-code' : 'off'"
      [attr.aria-label]="'Dígito ' + ($index + 1) + ' de ' + length"
      [attr.aria-invalid]="invalid ? 'true' : null"
      [value]="digits[$index] || ''"
      (input)="onInput($index, $any($event.target).value)"
      (keydown)="onKeydown($index, $event)"
      (paste)="onPaste($index, $event)"
      (focus)="$any($event.target).select()"
      (blur)="onBlur()">
  }
</div>
